import styled from "styled-components";
import { AuthLogo, ShareErrorIMG } from "@assets";
import { Button as AntButton, Space } from "antd";

export const RootContainer = styled.div`
  background: linear-gradient(156deg, #FFEBC6 13%, #D8A011 84.84%);
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 30px 16px 100px;
  min-height: 100vh;
`;

export const CloseContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  svg {
    cursor: pointer;
  }
`;

export const Welcome = styled.div`
  background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 145.455% */

  display: flex;
  align-items: center;
  justify-content: center;

  span {
    padding: 4px 4px 0px 4px;
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 12px;

  width: 100%;
`;

export const Logo = styled(AuthLogo)`
  margin: -5px auto 10px auto;
  width: 224px;
  height: 96px;
`

export const DescriptionContainer = styled.div`
  border-radius: 16px;
  background: #FFF;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.10);
  padding: 24px;
  width: 100%;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;

  overflow: hidden !important;
`;

export const Description = styled.div`
  color: #2A2A2A;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */

  width: 75%;

  span {
    color: #e8e03c;
  }

  @media screen and (max-width: 375px) {
    width: 90%;
  }
`;

export const Button = styled(AntButton)`
  width: 100% !important;
  height: 48px !important;

`;

export const FollowTitle = styled.div`
  background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 145.455% */
`;

export const FollowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  gap: 8px;

  #app {
    width: 100%;
    height: 48px;
  }

  svg{
    width: 40px;
    height: 40px;
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;

export const ErrorImage = styled.img.attrs({
  alt: "img",
  src: ShareErrorIMG,
})`
  width: 80px;
  object-fit: contain;
`;

export const ErrorTitle = styled.div`
  color: #2A2A2A;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
`;

export const ErrorDescription = styled.div`
  color: #5C5C5C;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; 
`;

export const UserName = styled.div`
  color: #2A2A2A;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */

  word-break: break-all;
`;

export const TypeInfo = styled.div`
  padding-bottom: 15px;
  color: var(--color-gold-solid, #D66700);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 183.333% */
`;

export const Loader = styled.div`
	width: 100%;
	height: calc(100vh);
	display: flex;
	align-items: center;
	justify-content: center;

  .ant-spin-dot i {
    background-color: #fff !important;
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: #FFD648;
`

export const DownloadWrapper = styled(Space).attrs({
	direction: "vertical",
})`
	gap: 15px !important;
	width: 100%;
  justify-content: center;
  align-items: center;

  svg{
    width: 100%;
    height: auto;
  }
`;